import React from 'react'
import { useLocation } from 'react-router-dom'
import AdminRoutes from '../AdminRoutes';
import WebRoutes from '../../web/src/WebRoutes';

export default function AppRoutes() {
  const {pathname} = useLocation();

  const isAdmin = pathname.startsWith("/portal");

  if(isAdmin){
    return (
      <AdminRoutes />
    )
  }
  return (
    <WebRoutes />
  )
}
